import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { defaultNS, useTranslation } from "@/lib/i18n";
import type { OnChangeFn } from "@dresscode-frontend/utility-types";
import { useCallback } from "react";

export type ReportStatusFilterValue = "all" | "completed" | "notCompleted";

type Props = {
  value?: ReportStatusFilterValue;
  onChange: OnChangeFn<ReportStatusFilterValue | undefined>;
};

const statusOptions: ReportStatusFilterValue[] = [
  "all",
  "completed",
  "notCompleted",
];

export function ReportStatusSelect({ value, onChange }: Props) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "domain.device.components.deviceFilters.reportStatus",
  });

  const handleValueChange = useCallback(
    (newValue: string) => {
      if (newValue === "all") {
        onChange(undefined);
      } else {
        onChange(newValue as ReportStatusFilterValue);
      }
    },
    [onChange],
  );

  return (
    <Select value={value ?? "all"} onValueChange={handleValueChange}>
      <SelectTrigger className="h-8 w-[180px]">
        <SelectValue placeholder={t("placeholder")} />
      </SelectTrigger>
      <SelectContent>
        {statusOptions.map((status) => (
          <SelectItem key={status} value={status}>
            {t(status)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
